import React, { useState, useEffect } from 'react';
import { Input, Modal, ModalBody } from '@windmill/react-ui';

import LabelArea from 'components/form/LabelArea';
import InputSearchDate from 'components/form/InputSearchDate';

const BillPaymentBulkModal = ({
	isOpen,
	onClose,
	title,
	handleSubmitReady,
	data,
	roundedOffDifference
}) => {
	const [utr, setUtr] = useState('');
	const [error, setError] = useState('');
	const [remark, setRemark] = useState('');

	const [paymentType, setPaymentType] = useState('');
	const [searchstartDate, setSearchStartDate] = useState(new Date());
	useEffect(() => {
		if (isOpen) {
			setPaymentType('');
			setSearchStartDate(new Date());
			setRemark('');
			setUtr('');
		}
	}, [isOpen]);

	const onSubmit = () => {
  let errorMsg = '';
  if (!searchstartDate) {
    errorMsg = 'Payment Date is required.';
  } else if (!paymentType) {
    errorMsg = 'Payment Type is required.';
  } else if (paymentType === 'Bank Transaction' && !utr) {
    errorMsg = 'UTR Number is required for Bank Transaction.';
  } else if (paymentType !== 'Bank Transaction' && !remark.trim()) {
    errorMsg = 'Remark is required for this payment type.';
  }

  if (errorMsg) {
    setError(errorMsg);
    return;
  }

  setError('');
  const updatedData = {
    paid_date: searchstartDate,
    payment_type: paymentType,
    utr: paymentType === 'Bank Transaction' ? utr : '',
    remark: remark,
    id: data, // pass array of ids
    roundedOffDifference: roundedOffDifference
  };

  handleSubmitReady(updatedData);
  onClose();
};


	return (
		<Modal
			className="relative bg-white p-5 dark:bg-gray-700 dark:text-white rounded-lg"
			style={{ width: '450px' }}
			isOpen={isOpen}
			onClose={onClose}
		>
			<ModalBody className="custom-modal" style={{ margin: '0' }}>
				<h2 className="text-center font-bold text-lg">{title}</h2>

				<div
					className="max-h-96 flex flex-col gap-5"
					style={{ maxHeight: '60vh', scrollbarWidth: 'thin' }}
				>
					<div className="flex flex-col flex-1">
						<LabelArea label="Payment Date" />
						<div className="w-100">
							<InputSearchDate
								value={searchstartDate}
								onChange={(event) => setSearchStartDate(event)}
							/>
						</div>
					</div>

					<div className="flex flex-col flex-1">
						<LabelArea label="Payment Type" />
						<select
							className=" bg-white border border-gray-200 h-10 text-sm block w-full  focus:bg-white focus:border-gray focus:ring-1 focus:ring-blue-500 rounded"
							name="payment_type"
							onChange={(e) => setPaymentType(e.target.value)}
						>
							value={paymentType}
							<option value="">Choose</option>
							<option value="Bank Transaction">Bank Transaction</option>
							<option value="Cash">Cash</option>
						</select>
					</div>
			{paymentType === 'Bank Transaction' && (
  <>
    <div className="flex flex-col flex-1">
      <LabelArea label="UTR Number" />
      <Input
        className={`border h-10 text-sm block w-full ${
          error && !utr ? 'border-red-500' : ''
        } focus:bg-white`}
        type="number"
        name="utr"
        placeholder="Enter UTR Number"
        value={utr}
        onChange={(e) => setUtr(e.target.value)}
      />
    </div>

    <div className="flex flex-col flex-1">
      <LabelArea label="Remark" />
      <Input
        className="border h-10 text-sm block w-full focus:bg-white"
        type="text"
        name="remark"
        placeholder="Enter remark"
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
    </div>
  </>
)}

{paymentType && paymentType !== 'Bank Transaction' && (
  <div className="flex flex-col flex-1">
    <LabelArea label="Remark" />
    <Input
      className="border h-10 text-sm block w-full focus:bg-white"
      type="text"
      name="remark"
      placeholder="Enter remark "
      value={remark}
      onChange={(e) => setRemark(e.target.value)}
    />
  </div>
)}


					{error && <p className="text-red-500 text-xs mt-1">{error}</p>}
					<div className="flex justify-around mt-3">
						<button
							onClick={onClose}
							className="btn btn-secondary px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
						>
							Cancel
						</button>
						<button
							onClick={onSubmit}
							className="btn btn-primary px-4 py-2 bg-green-500 text-white rounded-md"
						>
							Save
						</button>
					</div>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default BillPaymentBulkModal;
